export const HEADER_BREAK_POINT = '@media screen and (min-width: 960px)';
export const style = {
    main: {
        [HEADER_BREAK_POINT]: {
            backgroundColor: 'neutral.0',
            color: 'neutral.800'
        },
        backgroundColor: 'primary.800',
        color: 'neutral.0'
    },
    logo: {
        color: 'neutral.0'
    },
    navItem: {
        color: 'neutral.800'
    },
    activeNavItem: {
        color: 'primary.800'
    },
    navItemSeparator: {
        borderLeft: '1px solid #B4B2B1',
        display: 'inline-block',
        marginTop: 1,
        height: '30px'
    }
};
